// @core/api/endpoints/team/create_team.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreateTeamRequest,
  TeamResponse,
} from '../../../types/team';

const BASE_PATH = '/team';

/**
 * Create a new team
 * Creates a new team within the platform. The creating user automatically becomes the team owner with full administrative privileges.
 */
export async function CreateTeam(
  data: CreateTeamRequest,
  options?: RequestOptions
): Promise<TeamResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/`;
  const requestOptions = options;
  return client.post<TeamResponse>(requestPath, data, requestOptions);
}
